export default __webpack_public_path__ + "static/media/admin-customers.5cdff738.svg";